'use client'
import React from 'react'
import { SwiperSlide } from 'swiper/react'

import ZSwiper from '@/_components/universal/swiper/z-swiper'

import AGalleryImage from './a-gallery-image'
import { IGalleryImage, ISwiperConfig } from './gallery.types'

interface IAGallerySlideProps {
	images: IGalleryImage[]
	title?: string
	swiperConfig: ISwiperConfig
}

const AGallerySlide: React.FC<IAGallerySlideProps> = ({ images, title, swiperConfig }) => {
	if (!images || images.length === 0) {
		return null
	}

	return (
		<ZSwiper
			className='gallery-swiper'
			{...swiperConfig}
			navigationPosition={swiperConfig.navigationPosition || 'top'}
			title={title ? { show: true, text: title } : undefined}
		>
			{images.map((image, index) => (
				<SwiperSlide key={image.url}>
					<AGalleryImage {...image} index={index} />
				</SwiperSlide>
			))}
		</ZSwiper>
	)
}

export default AGallerySlide
